import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { CrudStore } from 'core/types/crudStore'
import { refreshActionRequest } from 'onboarding/features/actions/refreshActionRequestAction'

export const useTriggerRefreshRequestDetails = () => {
  const appDispatch = useAppDispatch()

  const triggerRefreshRequestDetails = useCallback(() => {
    // triggers re-fetching of fresh request data and re-render of component RequestDetail
    CrudStore.get(CrudStoreItemOnboarding.RequestList, 'req-detail').removeQueries(true)
    // trigger re-fetching of fresh actions data and re-render of component ActionList
    CrudStore.get(CrudStoreItemOnboarding.ActionsForGrid, 'actionList').removeQueries(true)
    // trigger re-fetching of fresh data in redux store
    appDispatch(refreshActionRequest())
  }, [appDispatch])

  return { triggerRefreshRequestDetails }
}
